module.exports = __webpack_public_path__ + "img/TAD.39e3fefa.png";